import React from "react";
import { useNavigate } from "react-router-dom";

import "../styles/Modal.css";

const resumeScore = `
Hello User,
Team is working on this Feature.

Sincerely,
Prabhakar Kumar
`;

const ResumeScoreModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/success-page");
  };
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 style={{ color: "#007bff" }}>📄 Generated Your Resume Score</h2>
        <pre
          style={{
            whiteSpace: "pre-wrap",
            background: "#f5f5f5",
            padding: "15px",
            borderRadius: "10px",
            color: "#333",
            maxHeight: "400px",
            overflowY: "auto",
            marginTop: "15px",
          }}
        >
          {resumeScore}
        </pre>

        <div style={{ marginTop: "20px", textAlign: "right" }}>
          <button
            onClick={handleClose}
            className="btn btn-secondary"
            style={{
              padding: "6px 16px",
              borderRadius: "6px",
              backgroundColor: "#00bcd4",
              color: "#fff",
              border: "none",
              fontWeight: "500",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumeScoreModal;
